import { FaFacebook, FaInstagram, FaTiktok, FaTools } from "react-icons/fa";
import { SiZapier, SiHubspot } from "react-icons/si";

const ExistingBusinessForm = ({ nextStep, setFormData, formData, onSubmit }) => {
  const platforms = [
    { name: "Facebook", icon: <FaFacebook /> },
    { name: "Instagram", icon: <FaInstagram /> },
    { name: "TikTok", icon: <FaTiktok /> },
  ];

  const marketingTools = [
    { name: "Zapier", icon: <SiZapier /> },
    { name: "HubSpot", icon: <SiHubspot /> },
    { name: "Klaviyo", icon: <FaTools /> }, // Placeholder icon for Klaviyo
  ];

  const handleSubmit = () => {
    onSubmit(formData);
    nextStep();
  };

  const handlePlatformToggle = (platform) => {
    const updatedPlatforms = formData.platformsUsed.includes(platform)
      ? formData.platformsUsed.filter((p) => p !== platform)
      : [...formData.platformsUsed, platform];
    setFormData((prev) => ({ ...prev, platformsUsed: updatedPlatforms }));
  };

  const handleToolToggle = (tool) => {
    const updatedTools = formData.marketingToolsUsed.includes(tool)
      ? formData.marketingToolsUsed.filter((t) => t !== tool)
      : [...formData.marketingToolsUsed, tool];
    setFormData((prev) => ({ ...prev, marketingToolsUsed: updatedTools }));
  };

  return (
    <div>
      <h2 className="text-2xl font-bold">Tell us about your existing business</h2>
      <div className="mt-6">
        <h3 className="text-lg">Do you have a website?</h3>
        <div className="flex space-x-4 mt-2">
          <button
            className={`px-4 py-2 rounded-lg ${
              formData.businessWebsite ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-800"
            }`}
            onClick={() => setFormData((prev) => ({ ...prev, hasWebsite: true }))}
          >
            Yes
          </button>
          <button
            className={`px-4 py-2 rounded-lg ${
              !formData.businessWebsite ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-800"
            }`}
            onClick={() => setFormData((prev) => ({ ...prev, hasWebsite: false, businessWebsite: "" }))}
          >
            No
          </button>
        </div>
        {formData.hasWebsite && (
          <div className="mt-4">
            <input
              type="text"
              placeholder="Enter your website URL"
              value={formData.businessWebsite}
              onChange={(e) => setFormData((prev) => ({ ...prev, businessWebsite: e.target.value }))}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )}
      </div>

      <h3 className="mt-6 text-lg">Platforms You Use</h3>
      <div className="flex space-x-4 mt-4">
        {platforms.map((platform) => (
          <button
            key={platform.name}
            className={`p-4 rounded-lg flex flex-col items-center ${
              formData.platformsUsed.includes(platform.name) ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-800"
            }`}
            onClick={() => handlePlatformToggle(platform.name)}
          >
            {platform.icon}
            <span className="mt-2 text-sm">{platform.name}</span>
          </button>
        ))}
      </div>

      <h3 className="mt-6 text-lg">Marketing Tools You Use</h3>
      <div className="flex space-x-4 mt-4">
        {marketingTools.map((tool) => (
          <button
            key={tool.name}
            className={`p-4 rounded-lg flex flex-col items-center ${
              formData.marketingToolsUsed.includes(tool.name) ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-800"
            }`}
            onClick={() => handleToolToggle(tool.name)}
          >
            {tool.icon}
            <span className="mt-2 text-sm">{tool.name}</span>
          </button>
        ))}
      </div>

      <button
        className="mt-6 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        onClick={handleSubmit}
      >
        Save and Continue
      </button>
    </div>
  );
};

export default ExistingBusinessForm;
